import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

// styles
import colors from '../../styles/colors'

// images
import TopImg from '../../assets/image/top/ic-top.svg'

function ScrollToTop({
  right, //
  bot, // [desktop, mobile]
}) {
  const [showBtn, setShowBtn] = useState(false)

  const handleScrollToTop = () => {
    window.scroll({
      top: 0,
      behavior: 'instant',
    })
  }

  const showButton = () => {
    // if (window.scrollY > 400) {
    if (window.scrollY > 200) {
      setShowBtn(true)
    } else {
      setShowBtn(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', showButton)

    return () => {
      window.removeEventListener('scroll', showButton)
    }
  }, [])

  return (
    <Container right={right} bot={bot}>
      {showBtn && <ScrollBtn onClick={handleScrollToTop} />}
    </Container>
  )
}

export default ScrollToTop

const Container = styled.div`
  position: absolute;
  /* right: ${(props) => `${props.right}px` ?? '0'};
  bottom: ${(props) => `-${props.bot[0] + 42}px` ?? '0'}; */
  display: flex;
  /* align-items: flex-end; */
  z-index: 9999;

  right: 0;
  top: 0;
  bottom: 0;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    /* bottom: ${(props) => `-${props.bot[1] + 42}px` ?? '0'}; */
    top: 16px;
    right: 20px;
  }
`

const ScrollBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 21px;
  background-color: ${colors.mainG};
  background: url(${TopImg});
  cursor: pointer;
`
